import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue'), meta: { title: '登录' } },
  {
    path: '/',
    component: () => import('@/layout/AdminLayout.vue'),
    redirect: '/dashboard',
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '经营总览', icon: 'el-icon-data-analysis' },
      },
      {
        path: 'stores',
        component: () => import('@/views/Stores.vue'),
        meta: { title: '门店管理', icon: 'el-icon-office-building', platform: true },
      },
      {
        path: 'products',
        alias: '/catalog',
        component: () => import('@/views/Catalog.vue'),
        meta: { title: '商品', icon: 'el-icon-goods' },
      },
      {
        path: 'services',
        component: { render: (h) => h('router-view') },
        redirect: '/services',
        meta: { title: '服务管理', icon: 'el-icon-s-order' },
        children: [
          {
            path: 'categories',
            alias: ['/service-categories'],
            component: () => import('@/views/ServiceCategories.vue'),
            meta: { title: '服务分类', icon: 'el-icon-collection-tag' },
          },
          {
            path: '',
            alias: ['list', '/services/list'],
            component: () => import('@/views/Services.vue'),
            meta: { title: '服务列表', icon: 'el-icon-tickets' },
          },
        ],
      },
      {
        path: 'ai-image',
        component: () => import('@/views/AiImagePresets.vue'),
        meta: { title: 'AI 写真配置', icon: 'el-icon-picture-outline' },
      },
      {
        path: 'marketing',
        component: () => import('@/views/Marketing.vue'),
        meta: { title: '运营配置', icon: 'el-icon-data-board', platform: true },
      },
      {
        path: 'legal-documents',
        component: () => import('@/views/LegalDocuments.vue'),
        meta: { title: '协议管理', icon: 'el-icon-document', platform: true },
      },
      {
        path: 'orders',
        component: () => import('@/views/Orders.vue'),
        meta: { title: '订单管理', icon: 'el-icon-tickets' },
      },
      {
        path: 'after-sales',
        component: () => import('@/views/AfterSales.vue'),
        meta: { title: '售后审核', icon: 'el-icon-sold-out' },
      },
      {
        path: 'reviews',
        component: () => import('@/views/Reviews.vue'),
        meta: { title: '评价管理', icon: 'el-icon-chat-line-square' },
      },
      {
        path: 'notifications',
        component: () => import('@/views/Notifications.vue'),
        meta: { title: '消息中心', icon: 'el-icon-bell' },
      },
      {
        path: 'appointments',
        component: () => import('@/views/Appointments.vue'),
        meta: { title: '预约排班', icon: 'el-icon-date' },
      },
      {
        path: 'boarding',
        component: () => import('@/views/Boarding.vue'),
        meta: { title: '寄养管理', icon: 'el-icon-house' },
      },
      {
        path: 'customers',
        component: () => import('@/views/Customers.vue'),
        meta: { title: '客户与宠物', icon: 'el-icon-user' },
      },
      {
        path: 'recharges',
        component: () => import('@/views/Recharges.vue'),
        meta: { title: '会员充值', icon: 'el-icon-bank-card' },
      },
      {
        path: 'staff',
        component: () => import('@/views/Staff.vue'),
        meta: { title: '员工权限', icon: 'el-icon-s-custom', manager: true },
      },
    ],
  },
  { path: '*', redirect: '/dashboard' },
]

function canAccess(to) {
  const role = store.state.user && store.state.user.role
  if (to.matched.some((v) => v.meta.platform) && role !== 'PLATFORM_ADMIN') return false
  if (
    to.matched.some((v) => v.meta.manager) &&
    role !== 'PLATFORM_ADMIN' &&
    role !== 'STORE_MANAGER'
  ) {
    return false
  }
  return true
}

const router = new Router({ mode: 'history', base: process.env.BASE_URL, routes })
router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title || '运营中心'} · 臻宠生活`
  const needAuth = to.matched.some((v) => v.meta.auth)
  if (needAuth) {
    if (!store.state.token) return next('/login')
    const ok = await store.dispatch('bootstrap')
    if (!ok) return next('/login')
    if (!canAccess(to)) return next('/dashboard')
    return next()
  }
  if (to.path === '/login' && store.state.token) {
    const ok = await store.dispatch('bootstrap')
    if (ok) return next('/dashboard')
  }
  next()
})

export default router
